import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';

import { LazyLoadImageModule } from 'ng-lazyload-image';  
import { NgxSpinnerModule } from "ngx-spinner"; 
import { MyApp } from './app.component';   
import { HomePage } from '../pages/home/home';
import { ConfigProvider } from '../providers/config/config';  
import { ServicioProvider } from '../providers/servicio/servicio';
import { HttpClientModule } from '@angular/common/http';
import { ComponentsModule } from '../components/components.module';
import { AuxiliarReportesProvider } from '../providers/auxiliar-reportes/auxiliar-reportes';
import { RgbProvider } from '../providers/rgb/rgb'; 
import { AuxiliarGeneralProvider } from '../providers/auxiliar-general/auxiliar-general';
import { ApiHttpProvider } from '../providers/api-http/api-http';
import { AuthProvider } from '../providers/auth/auth';
import { LocationsProvider } from '../providers/locations/locations';
import { PosLocationsProvider } from '../providers/pos-locations/pos-locations';
import { CatalogsProvider } from '../providers/catalogs/catalogs';
import { CatalogWriterProvider } from '../providers/catalog-writer/catalog-writer';
import { MermasProvider } from '../providers/mermas/mermas';
import { CheckinAdminProvider } from '../providers/checkin-admin/checkin-admin';
import { AdminUsuariosProvider } from '../providers/admin-usuarios/admin-usuarios';
import { RuntimeAppConfigProvider } from '../providers/runtime-app-config/runtime-app-config';

export function inicializarConfiguracionWeb(runtimeConfig: RuntimeAppConfigProvider) {
  return () => runtimeConfig.inicializar();
}

@NgModule({
  declarations: [ 
    MyApp, 
    HomePage   
  ],
  imports: [
    LazyLoadImageModule,
    BrowserModule,  
    NgxSpinnerModule,
    HttpClientModule,
    ComponentsModule,
    IonicModule.forRoot(MyApp)
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    ConfigProvider,
    ServicioProvider,
    AuxiliarReportesProvider,
    RgbProvider,
    AuxiliarGeneralProvider,
    ApiHttpProvider,
    AuthProvider,
    LocationsProvider,
    PosLocationsProvider,
    CatalogsProvider,
    CatalogWriterProvider,
    MermasProvider,
    CheckinAdminProvider,
    AdminUsuariosProvider,
    RuntimeAppConfigProvider,
    {
      provide: APP_INITIALIZER,
      useFactory: inicializarConfiguracionWeb,
      deps: [RuntimeAppConfigProvider],
      multi: true,
    }
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts